import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments';
import { ProfessionalBill } from '../../models';
import { Functions } from '../../utils';

@Injectable({
  providedIn: 'root',
})
export class ProfessionalBillService {
  private httpClient = inject(HttpClient);

  getProfessionalBills(
    queryParams: any = {},
  ): Observable<{ items: ProfessionalBill[]; total: number }> {
    const params: HttpParams = Functions.objectQueryToHttpParams(queryParams);

    return this.httpClient.get<{
      items: ProfessionalBill[];
      total: number;
    }>(environment.apiURL + '/professionals/invoices/', { params: params });
  }

  createProfessionalBill(professionalBill: any): Observable<ProfessionalBill> {
    return this.httpClient.post<ProfessionalBill>(
      environment.apiURL + '/professionals/invoices',
      professionalBill,
    );
  }

  updateProfessionalBill(professionalBillId: string, data: any): Observable<ProfessionalBill> {
    return this.httpClient.put<ProfessionalBill>(
      environment.apiURL + '/professionals/invoices/' + professionalBillId,
      data,
    );
  }
}
